import React from "react";
import HeaderProfile from "./HeaderProfile";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import TimerIcon from "@material-ui/icons/Timer";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import FastfoodIcon from "@material-ui/icons/Fastfood";
import AddIcon from "@material-ui/icons/Add";
export default function Profile() {
  return (
    <div className="Profile">
      <HeaderProfile />
      <h6>Profile</h6>
      <div className="main-container">
        <div className="left-side">
          <div className="box1">
            <ul>
              <li>
                Prep Time
                <KeyboardArrowRightIcon />
              </li>
              <li>
                Account
                <KeyboardArrowRightIcon />
              </li>
              <li>
                Finance
                <KeyboardArrowRightIcon />
              </li>
              <li>
                Users
                <KeyboardArrowRightIcon />
              </li>
              <li>
                FSSAI
                <KeyboardArrowRightIcon />
              </li>
              <li>
                GST
                <KeyboardArrowRightIcon />
              </li>
            </ul>
          </div>
        </div>
        <div className="right-side">
          <div className="box2">
            <div className="content">
              <h3>1. What is thePreparation Time?</h3>
              <p>
                It is the time you take to prepare food. Pack the items and mark
                the order ready for pickup
              </p>
              <div className="pictures">
                <div className="icons">
                  <TimerIcon className="icon1" fontSize="inherit" />
                  <AddIcon className="icon-plus" />
                  <LocalMallIcon className="icon2" fontSize="inherit" />
                  <AddIcon className="icon-plus" />
                  <FastfoodIcon className="icon3 " fontSize="inherit" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
